import {useEffect} from 'react';
import {requestApi, validateUser} from "../../utils/utils";
import {useSignOut} from "react-auth-kit";
import {useHistory, useLocation} from "react-router-dom";


const ValidateAccess = () => {
    const signOut = useSignOut();
    const {search} = useLocation();
    const history = useHistory();
    const searchParams = new URLSearchParams(search);
    const accessToken = searchParams.get("access");
    if (accessToken) sessionStorage.setItem('accessToken', accessToken);

    useEffect(() => {
        validation().catch();
    }, []);

    const validation = async () => {
        const guestCode = sessionStorage.getItem('accessToken');
        try {
            if (guestCode) {
                const {data} = await requestApi('/guest/valid-access-token', 'POST', {guestCode});
                if (data.valid) return;

                sessionStorage.removeItem('accessToken');
            }

            const token = localStorage.getItem('user');
            if (!token) return goToLogin();
            const isAuthenticated = await validToken(token);
            if (!isAuthenticated) return goToLogin();

        } catch (e) {
            return goToLogin();
        }
    };

    const validToken = async () => {
        const data = await validateUser();
        if (data.status === 'success' && data.validate) return true;

        signOut();
        return false;
    };

    const goToLogin = () => history.push('/booking/login');

    return null;
};

export default ValidateAccess;
